import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';

interface Props {
  data: InsuranceDTO;
}

export const InsuredSelect = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const options = data.Options.LifeInsuranceInsuredMemberOptions.map(member => ({
    label: member,
    value: member,
  }));

  return (
    <Controller
      control={formBag.control}
      name="LifeInsuredMember"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label="Insured"
            value={value ? { value, label: value } : null}
            options={options}
            onChange={opt => onChange(opt?.value)}
            isPortal
          />
        );
      }}
    />
  );
};
